import { Injectable } from "@angular/core";
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  NavigationEnd,
  CanActivateChild,
} from "@angular/router";
import { Observable } from "rxjs";
import { RestService } from "../rest.service";
import { RoleAccessService } from "../roleaccess.service";
import { NotificationService } from "../notification.service";
import { url } from "inspector";

@Injectable({ providedIn: "root" })
export class AuthGuard implements CanActivate, CanActivateChild {
  public screenMaster: any = [];
  public urlSkipArrayList: string[] = [
    "/log-out",
    "/risk/view",
    "/risk/controltesting",
    "/risk/riskfilter",
    "/risk/mitigation",
    "/incident/view",
    "/risk/upload",
    "risk/addRisk",
    "risk/add-mitigation",
  ];
  constructor(
    private router: Router,
    private restService: RestService,
    private roleAccessService: RoleAccessService,
    private notify: NotificationService
  ) {}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const urlName = state.url;
    if (sessionStorage.getItem("employeeId")) {
      if (urlName != null) {
        if (!this.checkPartialUrlMatch(urlName)) {
          this.roleAccessService.getRoleAccess(urlName).then((data) => {
            const accessControl = data;
            if (accessControl != null) {
              if (accessControl.moduleAccess == 1) {
                this.router.navigateByUrl(urlName);
              } else {
                this.notify.showError("Access Denied", "");
                this.router.navigateByUrl("/403-page");
              }
            }
          });
        }
      }
      return true;
    }

    this.router.navigateByUrl("/login");
    return false;
  }
  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    return this.canActivate(childRoute, state);
  }
  checkPartialUrlMatch(url: string): boolean {
    return this.urlSkipArrayList.some((item) => {
      const regex = new RegExp(item, "i");
      return regex.test(url);
    });
  }
}
